import { render, staticRenderFns } from "./CotizacionModal.vue?vue&type=template&id=123566dc&"
import script from "./CotizacionModal.vue?vue&type=script&lang=ts&"
export * from "./CotizacionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports